export const toTitleCase = (str: string) => {
  if (str.length === 0) {
    return "";
  }
  return str
    .split(" ")
    .filter((word) => word.trim().length > 0)
    .map((word) => {
      return word[0].toUpperCase() + word.slice(1);
    })
    .join(" ");
};
